export const TAGS = [
    { id: 'overall_performance', label: 'Overall' },
    { id: 'geo_performance', label: 'Geo' },
    { id: 'search_appearance_performance', label: 'Search Appearance' },
    { id: 'keyword_clusters', label: 'Keyword Clusters', filter: 'decline' },
    { id: 'urls', label: 'URLs', filter: 'decline' },
    { id: 'directories', label: 'Directories', filter: 'decline' },
    { id: 'ctr', label: 'CTR' },
];
